// extracted by mini-css-extract-plugin
export default {"dark_balance":"wallet_dark_balance__H4PdC","light_balance":"wallet_light_balance__x1s7g","dark_price":"wallet_dark_price__-UBXY","light_price":"wallet_light_price__Yzya5"};